import * as React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { ICartState } from '@msdyn365-commerce/global-state';
import { SimpleProductExt } from '../../shared-utils/types';
import { humanizeUnitOfMeasure } from '../unit-of-measure';
import { format, Tooltip } from '@msdyn365-commerce-modules/utilities';

export interface ICartCountProps {
    context: ICoreContext;
    cart: ICartState;
    product: SimpleProductExt;
    inCartTooltipText?: string;
}

const CartCount: React.FC<ICartCountProps> = ({ context, cart, product, inCartTooltipText }) => {
    const [showCartCountTooltip, setShowCartCountTooltip] = React.useState<boolean>(false);
    const cartQuantity = cart?.cart.CartLines?.filter(x => x.ProductId === product.RecordId).reduce(
        (acc, val) => acc + (val.Quantity || 0),
        0
    );

    if (!cartQuantity) {
        return null;
    }

    const baseClassName = 'defa-cart-count';
    const cartCountId = `cart-count-${product.RecordId}`;
    const humanizedUOM = humanizeUnitOfMeasure(context, product.DefaultUnitOfMeasure).toLowerCase();
    const tooltipString = inCartTooltipText || '{0} {1} i handlekurven';
    const tooltipText = format(tooltipString, cartQuantity, humanizedUOM);

    return (
        <div
            id={cartCountId}
            className={baseClassName}
            onMouseOver={() => setShowCartCountTooltip(true)}
            onMouseOut={() => setShowCartCountTooltip(false)}
            onTouchStart={() => setShowCartCountTooltip(true)}
        >
            {cartQuantity}
            <Tooltip isOpen={showCartCountTooltip} target={`#${cartCountId}`} className={`${baseClassName}__tooltip`}>
                {tooltipText}
            </Tooltip>
        </div>
    );
};

export default CartCount;
